<template>
	<div class="tpl vip-center-wrap">
		<mt-header title="会员中心" fixed>
			<router-link :to="{name:'mine'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
		</mt-header>
		<div id="vip-banner-wrap">
			<div class="swiper-container">
				<div class="swiper-wrapper">
					<div class="swiper-slide"><img src="../../assets/img/vip/vip1.png" /></div>
					<div class="swiper-slide"><img src="../../assets/img/vip/vip2.png" /></div>
					<div class="swiper-slide"><img src="../../assets/img/vip/vip3.png" /></div>
					<div class="swiper-slide"><img src="../../assets/img/vip/vip4.png" /></div>
				</div>
			</div>
		</div>
		<p class="tips">下载鱼水缘App享受更优质的会员体验哦~</p>
		<div class="vip-wrap" v-if="show==0">
			<p class="wrap-title" style="color: #5415F9;">黄金会员vip尊享特权</p>
			<div class="vip-item" v-for="(item,index) in vip1Content">
				<p class="item-title">
					<span class="line"></span>{{item.classification}}<span class="line"></span>
				</p>
				<div class="item-list">
					<ul>
						<li v-for="(i,n) in item.arr" @click="toDetail(index,n)"><span class="item-img"><img :src="i.privilege_img"/></span><p>{{i.privilege_name}}</p></li>
					</ul>
				</div>
			</div>
			
		</div>
		<div class="vip-wrap" v-if="show==1">
			<p class="wrap-title" style="color: #FF6161;">铂金会员vip尊享特权</p>
			<div class="vip-item" v-for="(item,index) in vip2Content">
				<p class="item-title">
					<span class="line"></span>{{item.classification}}<span class="line"></span>
				</p>
				<div class="item-list">
					<ul>
						<li v-for="(i,n) in item.arr" @click="toDetail(index,n)"><span class="item-img"><img :src="i.privilege_img"/></span><p>{{i.privilege_name}}</p></li>
					</ul>
				</div>
			</div>
		</div>
		<div class="vip-wrap" v-if="show==2">
			<p class="wrap-title" style="color: #01AEF0;">钻石会员vip尊享特权</p>
			<div class="vip-item" v-for="(item,index) in vip3Content">
				<p class="item-title">
					<span class="line"></span>{{item.classification}}<span class="line"></span>
				</p>
				<div class="item-list">
					<ul>
						<li v-for="(i,n) in item.arr" @click="toDetail(index,n)"><span class="item-img"><img :src="i.privilege_img"/></span><p>{{i.privilege_name}}</p></li>
					</ul>
				</div>
			</div>
		</div>
		<div class="vip-wrap" v-if="show==3">
			<p class="wrap-title" style="color: #d4b483;">高级会员vip尊享特权</p>
			<div class="vip-item" v-for="(item,index) in vip4Content">
				<p class="item-title">
					<span class="line"></span>{{item.classification}}<span class="line"></span>
				</p>
				<div class="item-list">
					<ul>
						<li v-for="(i,n) in item.arr" @click="toDetail(index,n)"><span class="item-img"><img :src="i.privilege_img"/></span><p>{{i.privilege_name}}</p></li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import 'swiper/dist/css/swiper.css';

	import Swiper from 'swiper';
	export default{
		name:"vip-center",
		data(){
			return{
				uid:"",
				show:0,
				vip1Content:"",
				vip2Content:"",
				vip3Content:"",
				vip4Content:"",
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);
			
			this.getBaseInfo();
			
			let _this = this;
				setTimeout(function(){
					var swiper = new Swiper('.swiper-container',{
					slidesPerView: 1.2,
					centeredSlides: true,
					on: {
					    slideChange: function(event){
					      _this.show = swiper.realIndex;
					      console.log(_this.show)
					    },
					}
				})
			},10)
		},
		methods:{
			getBaseInfo(){
				this.$axios.get("My/IosFirstClassMember").then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.vip1Content = res.data.data[0].privilege;
						this.vip2Content = res.data.data[1].privilege;
						this.vip3Content = res.data.data[2].privilege;
						this.vip4Content = res.data.data[3].privilege;
						console.log(this.vip1Content)
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			toDetail(n,i){
				console.log(this.show+1,n+1,i);
				this.$router.push({
					name:"vip-detail",
					query:{
						vid:this.show+1,
						part:n+1,
						index:i
					}
				})
			}
		}
	}
</script>

<style scoped>
	.vip-center-wrap{
		padding-top: 2.5rem;
	}
	.mint-header{
		z-index: 10;
	}
	.swiper-container {
      width: 100%;
      height: 100%;
    }
    .swiper-slide {
      text-align: center;
      font-size: 18px;

      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
    }
    .swiper-slide img{
    	width: 100%;
    }
    #vip-banner-wrap{
    	padding: 0.5rem 0 0;
      	background: #fff;
    }
    .tips{
    	font-size: 0.8rem;
    	line-height: 1.2rem;
    	color: #5415F9;
    	background: rgba(84,21,249,.2);
    	padding: 0.5rem 1.5rem;
    	opacity: 0.8;
    }
    .vip-wrap{
    	margin-top: 0.5rem;
    	padding-bottom: 1rem;
    }
    .vip-wrap .wrap-title{
    	font-size: 0.9rem;
    	color: #875BFB;
    	line-height: 1.5rem;
    	background: #fff;
    	padding: 0.3rem 1rem;
    }
    .vip-wrap{
    	background: #fff;
    }
    .vip-wrap .item-title{
    	display: flex;
    	justify-content: center;
    	align-items: center;
    	font-size: 0.8rem;
    	color: #7b7b7b;
    	margin: 0.5rem 0;
    }
    .vip-wrap .item-title .line{
    	width: 3rem;
    	border-bottom: 1px solid #f3f3f3;
    	margin: 0 0.5rem;
    }
    .vip-wrap .item-img{
    	width: 2.8rem;
    	height: 2.8rem;
    	background: rgba(234,188,143,.3);
    	display: inline-block;
    	border-radius: 50%;
    	padding: 0.5rem;
    	box-sizing: border-box;
    }
    .vip-wrap .item-img img{
    	width: 100%;
    }
    .vip-wrap .item-list p{
    	font-size: 0.65rem;
    	color: #282828;
    	line-height: 1.5rem;
    }
    .vip-wrap .item-list ul{
    	display: flex;
    	justify-content: flex-start;
    	align-items: center;
    	flex-wrap: wrap;
    }
    .vip-wrap .item-list li{
    	width: 25%;
    	text-align: center;
    	padding: 0.3rem 0 0.2rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/Mine/VipCenter.vue